import apiFetch from '@scale/frontend-lib/api-fetch';
import { ITrait, PipelineV3AllTraitsByPipelineResponse } from '@scale/shared-types';

export async function getAllTraits(): Promise<PipelineV3AllTraitsByPipelineResponse> {
  const res = await apiFetch<PipelineV3AllTraitsByPipelineResponse, {}>(
    null,
    `corp-api/pipelinev3/get-all-traits`,
    {
      method: 'POST',
    },
  );

  res.traits.sort((lhs: ITrait, rhs: ITrait) => lhs.pipeline.localeCompare(rhs.pipeline));

  return res;
}
